import { css, Interpolation, Theme } from '@emotion/react'
import { useEffect, useState } from 'react'
import Select, { ActionMeta, SingleValue } from 'react-select'

type Props = {
  initialValue?: string
  isSearchable?: boolean
  isClearable?: boolean
  addStyle?: Interpolation<Theme>
  customStyles?: any
  onChange?: (
    newValue: SingleValue<{ label: string; value: string }>,
    actionMeta: ActionMeta<{ label: string; value: string }>,
  ) => void
}

const style = css`
  width: 25rem;
`
const honorificData = [
  { label: '様', value: '1' },
  { label: '殿', value: '2' },
  { label: '長　殿', value: '3' },
]
// TODO : のデータをAPIから取得するようにする。anyを使わないようにする。
export const HonorificSelect = ({
  onChange,
  isSearchable,
  initialValue,
  isClearable,
  addStyle,
  customStyles,
}: Props) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>([])
  const [value, setValue] =
    useState<SingleValue<{ label: string; value: string }>>(null)

  useEffect(() => {
    const newOptions = honorificData.map((type: any) => ({
      label: type.label,
      value: type.value,
    }))
    setOptions(newOptions)

    const initialOption = newOptions.find(
      (opt: any) => opt.value === initialValue,
    )
    setValue(initialOption || null)
  }, [initialValue])

  const handleChange = (
    newValue: SingleValue<{ label: string; value: string }>,
    actionMeta: ActionMeta<{ label: string; value: string }>,
  ) => {
    setValue(newValue)
    onChange?.(newValue, actionMeta)
  }

  return (
    <Select
      css={[style, addStyle]}
      isSearchable={isSearchable}
      value={value}
      placeholder="敬称を選択"
      name="honorific"
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      styles={customStyles}
    />
  )
}
